export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Гібрид соняшнику НС Оскар. Дуже ранній гібрид з періодом вегетації 90-95 днів та потенційною урожайністю 5 т/га. Генетично стійкий до несправжньої борошнистої роси (Pl7 ген), до іржі та соняшникової молі, стійкий до A-G++ рас вовчка. Рослина з міцним і сильним стеблом, стійким до вилягання, добре переносить посуху, привабливий для запилювачів та відрізняється дуже високим ступенем запліднення.
                </p>
                <p className="card__description-title">
                    Характеристики
                </p>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Генетичний потенціал врожайності</td>
                        <td className="card__description__th-index">50 ц/га</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Група стиглості</td>
                        <td className="card__description__th-index">90-95 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Тип</td>
                        <td className="card__description__th-index">Екстенсивний</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослини</td>
                        <td className="card__description__th-index">160-180 см</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність</td>
                        <td className="card__description__th-index">46-49%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Рекомендовані зони вирощування</td>
                        <td className="card__description__th-index">Лісостеп, Полісся</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Стійкість до вовчка</td>
                        <td className="card__description__th-index">A-G++</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Короткі дані
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія початкового росту: 9/10</li>
                    <li className="card__description-numbering">Посухостійкість: 8/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання: 8/10</li>
                    <li className="card__description-numbering">Толерантність до фомопсису: 9/10</li>
                    <li className="card__description-numbering">Толерантність до іржі: 9/10</li>
                </ol>
                <div className="card__description-title">Врожайність</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Кіровоградська область, Голованівський район, 39 ц/га</li>
                    <li className="card__description-numbering">Кіровоградська область, Бобринецький район, 37 ц/га</li>
                    <li className="card__description-numbering">Дніпропетровська область, Магдалинівський район, 35 ц/га</li>
                    <li className="card__description-numbering">Миколаївська область, Вознесенський район, 36 ц/га</li>
                    <li className="card__description-numbering">Одеська область, Березівський район, 31 ц/га</li>
                </ol>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
